import * as React from 'react';

import * as styles from './ProjectsListLayout.css';

interface IProjectsListLayoutProps {
  children?: React.ReactNode;
}

export const ProjectsListLayout: React.FC<IProjectsListLayoutProps> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
